/**
 * Handle main navigation
 */
export default class Navigation {
    constructor() {
        this.$body = document.body;
        this.$hamburger = document.querySelector('.navigation__hamburger');
        this.$close = document.querySelector('.navigation__close');

        this.init();
    }

    init() {
        this.eventToggleNavigation();
    }

    toggleNavigation(state) {
        this.$body.classList.toggle('navigation--visible', state);
        this.$body.classList.toggle('scroll-hide', state);
    }

    eventToggleNavigation() {
        [this.$hamburger, this.$close].forEach(($trigger) => {
            $trigger.addEventListener('click', () => {
                this.toggleNavigation(!this.$body.classList.contains('navigation--visible'));
            });
        })
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/components/navigation/Navigation.js